/* import __COLOCATED_TEMPLATE__ from './fly-styled-checkbox.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { htmlSafe } from '@ember/template';
/**
  FlyStyledCheckbox is a component that accepts any HEX color to make a colored checkbox.

  ```hbs
  <FlyStyledCheckbox
    /@checked={{this.checked}}
    /@name="checkbox_name"
    /@color="#facade"
    /@colorBorder={{true}}
    /@label="Check this out"
    /@onChange={{this.onCheckboxChange}}
  />
  ```

  @class FlyStyledCheckbox
  @public
 */
let FlyStyledCheckbox = (_class = class FlyStyledCheckbox extends Component {
  get checkboxStyle() {
    let style = '';
    if (this.args.color != null) {
      style += `--styled-checkbox-color: ${this.args.color};`;
    }
    if (this.args.backgroundColor != null) {
      style += `--styled-checkbox-background-color: ${this.args.backgroundColor};`;
    }
    return htmlSafe(style);
  }
  get indeterminate() {
    return this.args.indeterminate ?? false;
  }
  get inputId() {
    return this.args.inputId ?? `${this.args.value}_${guidFor(this)}`;
  }
  onInputClicked(event) {
    if (this.args.disabled || !this.args.onChange) {
      return;
    }
    let metadata = {
      event
    };
    this.args.onChange(event.target.checked, metadata);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onInputClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputClicked"), _class.prototype)), _class);
export { FlyStyledCheckbox as default };